import React from "react";
import SignupBox from "./SignupBox";
import LoginAuth from "../PrivateRoutes/LoginAuth";
import "./Signup.css";

const Signup = () => {
  return (
    <LoginAuth>
      <div className="bg-[#0d0d0d] w-full flex justify-center items-center py-6 min-h-[100vh]">
        <SignupBox />
      </div>
    </LoginAuth>
  );
};

export default Signup;
